export const ADDON_ID = "storybook-addon-mock-date";
export const TOOL_ID = `${ADDON_ID}/tool`;
export const PARAM_KEY = `${ADDON_ID}/mocking-date`;
